import type { TreeNode } from "../../file-tree-manager/types/tree-types"

export const findNodeById = (nodes: TreeNode[], id: string): TreeNode | null => {
  for (const node of nodes) {
    if (node.id === id) return node
    if (node.children) {
      const found = findNodeById(node.children, id)
      if (found) return found
    }
  }
  return null
}

export const getNodePath = (nodes: TreeNode[], targetId: string, currentPath: string[] = []): string[] | null => {
  for (const node of nodes) {
    const newPath = [...currentPath, node.title]
    if (node.id === targetId) return newPath
    if (node.children) {
      const result = getNodePath(node.children, targetId, newPath)
      if (result) return result
    }
  }
  return null
}

export const updateTree = (nodes: TreeNode[], updater: (node: TreeNode) => TreeNode): TreeNode[] => {
  return nodes.map((node) => {
    const updated = updater(node)
    if (updated.children) {
      return { ...updated, children: updateTree(updated.children, updater) }
    }
    return updated
  })
}

export const getChildrenCount = (node: TreeNode): { folders: number; files: number } => {
  let folders = 0
  let files = 0
  const countRecursive = (children: TreeNode[]) => {
    for (const child of children) {
      if (child.type === "folder") folders++
      else files++
      if (child.children) countRecursive(child.children)
    }
  }
  if (node.children) countRecursive(node.children)
  return { folders, files }
}

export const isValidDropTarget = (draggedId: string, targetId: string, treeData: TreeNode[]): boolean => {
  if (draggedId === targetId) return false
  const isDescendant = (parentId: string, childId: string, nodes: TreeNode[]): boolean => {
    const parent = findNodeById(nodes, parentId)
    if (!parent || !parent.children) return false
    for (const child of parent.children) {
      if (child.id === childId) return true
      if (child.children && isDescendant(child.id, childId, nodes)) return true
    }
    return false
  }
  // 대상이 자신의 하위 노드가 아니어야 함
  if (isDescendant(draggedId, targetId, treeData)) return false
  return true
}


